angular.module('leanlaw').config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('featureInterceptor');
}]).factory('featureInterceptor', ['leanLawAuth', function (leanLawAuth) {
  // This adds the features from both leanLawAuth and from windows.llexperiments
  // to the request. features come from app.local.js for local development
  // and the experiments are defined in vwo and sent to the back-end through
  // this interceptor so that vwo experiments are noted by api.
  var features = leanLawAuth.features || {};
  if (window.llexperiments) {
    _.each(window.llexperiments, e => features[e] = true);
  }
  var list = [];
  for (var feature in features) {
    if (features.hasOwnProperty(feature) && features[feature]) {
      list.push(feature);
    }
  }
  var _features = list.length > 0 ? list.join(',') : false;
  return {
    request: function (config) {
      if (_features) {
        config.headers["x-leanlaw-features"] = _features;
      }
      return config;
    }
  };
}]);